var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "actions-bar" },
    _vm._l(_vm.buttons, function (button, index) {
      return _c(
        "button",
        {
          key: index,
          class: _vm.getClassStyle(button),
          attrs: { title: button.tooltip, disabled: _vm.disabledButtons },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.executeAction(button.action, index)
            },
          },
        },
        [
          _vm.isSquareButton(button)
            ? _c("span", [_vm._v(_vm._s(button.tooltip))])
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }